import { Alert, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../contexts/AuthContext';

// Mounted on every page (AppLayout). When the selected Shopify store's
// offline token chain is broken — Shopify rejected a refresh (auth_broken)
// or the refresh token is gone (reauth_required) — the way back is the
// standalone app's door for that shop (`shopify_sign_in_url`, built by the
// backend): it runs the offline OAuth leg first and the per-user leg lands
// the merchant back on this SaaS signed in, so it opens in the same tab.
const RECONNECT_HEALTH = new Set(['auth_broken', 'reauth_required']);

export default function StoreConnectionBanner() {
  const { t } = useTranslation();
  const { selectedStore } = useAuth();

  if (!selectedStore || selectedStore.store_type !== 'shopify') {
    return null;
  }
  if (!RECONNECT_HEALTH.has(selectedStore.shopify_health)) {
    return null;
  }

  return (
    <Alert
      severity="warning"
      sx={{ borderRadius: 0, mb: 0 }}
      action={
        <Button
          color="inherit"
          size="small"
          href={selectedStore.shopify_sign_in_url}
          sx={{ fontWeight: 'var(--font-weight-semibold)' }}
        >
          {t('storeSettings.reconnectLink')}
        </Button>
      }
    >
      {t('storeSettings.authBroken')}
    </Alert>
  );
}
